import React, { useState, useRef, useEffect } from "react";
import {
  useStyles,
  Wrapper,
  WrapperIcon,
  WrapperIconNoMargin,
} from "./style";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "../searchDropDown/searchDropHook";
import SearchAutocomplete from "../searchDropDown/searchAutoComplete";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { NewFolderDocPlace } from "../files/newFolder";
import { DownloadFolderZipModal } from "../files/DownloadFolderZipModal";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import {
  postFolderDownloadZip,
  folderDownloadZipPostClearData,
} from "../../../../store/explorer/actions";
import { useDispatch, useSelector } from "react-redux";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import iconSearch from "../../../../assets/search@2x.png";

import RecentIcon from "@mui/icons-material/PendingActions";

import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Divider from "@mui/material/Divider";
import { useReadOnlyStatus } from "../../../../helpers/legacyReadOnly";
import { getSearchArchivesList } from "../../../../store/actions";
import { colors } from "../../../../components/theme";
import { Backspace } from "@material-ui/icons";
import CircularProgress from "@mui/material/CircularProgress";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";

export function NavDocPlace(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showRootFolderModal, setShowRootFolderModal] = React.useState(false);
  const [showDownloadZipV2Modal, setShowDownloadZipV2Modal] =
    React.useState(false);
  const [downloadZipV2Folder, setDownloadZipV2Folder] = React.useState(null);

  const { responseFolderDownload, loadingFolderDownload } = useSelector(
    (state) => ({
      responseFolderDownload: state.Explorer.responseFolderDownload,
      loadingFolderDownload: state.Explorer.loadingFolderDownload,
    })
  );
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const inputRef = useRef(null);
  const paperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchAnchorEl &&
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        !paperRef.current?.contains(e.target)
      ) {
        setSearchAnchorEl(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchAnchorEl]);
  
  // Close dropdown when search query is cleared
  useEffect(() => {
    if (!props.searchQuery || props.searchQuery.trim() === "") {
      setSearchAnchorEl(null);
    }
  }, [props.searchQuery]);

  // Read-only (migrated) workspace: disable upload / new-folder actions.
  const { readOnly } = useReadOnlyStatus();

  // When zip download response arrives, trigger download with the requested folder name and clear state
  useEffect(() => {
    if (!responseFolderDownload) return;
    const blob =
      responseFolderDownload.blob != null
        ? responseFolderDownload.blob
        : responseFolderDownload;
    const folderName =
      responseFolderDownload.folderName != null
        ? responseFolderDownload.folderName
        : "folder";
    const url = URL.createObjectURL(
      new Blob([blob], { type: "application/zip" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = `${folderName}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    dispatch(folderDownloadZipPostClearData());
  }, [responseFolderDownload, dispatch]);

  const currentPath = props.mapPath.map((m) => m.name).join(" > ");
  const navigate = useNavigate();

  const handleSearchFocus = (event) => {
    setSearchAnchorEl(event.currentTarget);
  };

  const handleSearchBlur = () => {
    setTimeout(() => setSearchAnchorEl(null), 200);
  };

  const handleSearchChange = (e) => {
    const val = e.target.value;
    props.setSearchQuery(val);
    // Close dropdown immediately when input is cleared
    if (!val || val.trim() === "") {
      setSearchAnchorEl(null);
    }
    debouncedSearch(val);
  };
  const handleSelectResult = (file) => {
    props.handleSelectFile(file);
    props.setSearchQuery("");
  };

  const handleSearchClick = () => {
    if (props.searchQuery) {
      console.log("Search query in nav:", props.searchQuery);
      props.handleSearchClick(props.searchQuery);
    }
  };

  const handleViewAll = () => {
    console.log("View all query:", props.searchQuery);
    props.handleSearchClick(props.searchQuery);
    setSearchAnchorEl(null);
  };

  const debouncedSearch = useDebounce((query) => {
    if (query) {
      let obTerm = {
        filters: [],
        fullTextSearch: { text: query, fields: [] },
      };

      dispatch(
        getSearchArchivesList(
          {
            parentArchiveId:
              props.mapPath.length > 0
                ? props.mapPath[props.mapPath.length - 1].id
                : "",
            page: 1,
            pageSize: 50,
            obTerm,
          },
          navigate
        )
      );
    }
  }, 500);

  const refresh = (item) => {
    props.refresh(item);
  };

  const uploadFile = (item) => {
    props.refresh(item);
  };
  const createNewFolder = () => {
    showFolder(true);
  };

  const openMenuItems = () => {
    props.callBackOptionMenuItemsOpen();
  };

  const clearTrashBin = () => {
    props.clearTrash();
  };

  const [anchorFilter, setAnchorFilter] = React.useState(null);

  const handleFilterClick = (event) => {
    setAnchorFilter(anchorFilter ? null : event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorFilter(null);
  };

  const isFilterOpen = Boolean(anchorFilter);

  let activeFolder = props.mapPath[props.mapPath.length - 1];
  const downloadFolder = () => {
    let folderName = activeFolder?.name;
    let obj = [activeFolder?.id];
    dispatch(postFolderDownloadZip(folderName, obj));
  };
  const downloadFolderV2 = () => {
    setDownloadZipV2Folder({
      name: activeFolder?.name,
      id: activeFolder?.id,
    });
    setShowDownloadZipV2Modal(true);
  };
  const closeDownloadZipV2Modal = () => {
    setShowDownloadZipV2Modal(false);
    setDownloadZipV2Folder(null);
  };

  const callNewFolder = (name, item) => {
    setShowRootFolderModal(false);
    props.newFolder({ name: name, item: item });
  };

  const closeModal = () => {
    setShowRootFolderModal(false);
  };

  const showFolder = (item) => {
    setShowRootFolderModal(true);
  };

  return (
    <Wrapper>
      <NewFolderDocPlace
        newFolder={callNewFolder.bind(this)}
        close={closeModal.bind(this)}
        show={showRootFolderModal}
      />
      <DownloadFolderZipModal
        open={showDownloadZipV2Modal}
        onClose={closeDownloadZipV2Modal}
        folderName={downloadZipV2Folder?.name}
        archiveIds={downloadZipV2Folder?.id ? [downloadZipV2Folder.id] : []}
      />
      {/* <Grid container spacing={2}>
        <Grid item xs={12}> */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          gap: "16px",
          flexWrap: "nowrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: 12,
            flexShrink: 0,
            minWidth: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip title={readOnly ? "Read-only — upload in the new platform" : "Upload"} arrow>
              <span>
                <Button
                  aria-label="Upload"
                  disabled={readOnly}
                  onClick={() => {
                    if (readOnly) return;
                    if (typeof props.onUploadPrimaryClick === "function") {
                      props.onUploadPrimaryClick();
                    } else if (typeof props.toggleUploadUI === "function") {
                      props.toggleUploadUI();
                    }
                  }}
                  variant="contained"
                  color="success"
                  startIcon={readOnly ? <LockOutlinedIcon /> : <UploadFileIcon />}
                  sx={{
                    height: 36,
                    fontWeight: 700,
                    textTransform: "none",
                    borderRadius: 1,
                    px: 2,
                    minWidth: 132,
                  }}
                >
                  Upload
                </Button>
              </span>
            </Tooltip>
            {readOnly ? (
              <Chip
                icon={<LockOutlinedIcon />}
                label="Read-only workspace"
                sx={{
                  height: 36,
                  fontWeight: 600,
                  borderRadius: 1,
                  bgcolor: "#EEF4FF",
                  color: "#1E40AF",
                  "& .MuiChip-icon": { color: "#2563EB" },
                }}
              />
            ) : (
              <Tooltip title="Create New Folder" arrow>
                <Button
                  aria-label="Create New Folder"
                  onClick={() => setShowRootFolderModal(true)}
                  variant="outlined"
                  color="primary"
                  startIcon={<CreateNewFolderOutlinedIcon />}
                  sx={{
                    height: 36,
                    fontWeight: 700,
                    textTransform: "none",
                    borderRadius: 1,
                    px: 2,
                    minWidth: 140,
                  }}
                >
                  New Folder
                </Button>
              </Tooltip>
            )}
          </Box>

          <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Back" arrow>
              <span>
                <WrapperIcon
                  aria-label="Back"
                  style={{
                    backgroundColor: props.canGoBack ? "#fff" : "#e0e0e0",
                    cursor: props.canGoBack ? "pointer" : "not-allowed",
                    opacity: props.canGoBack ? 1 : 0.5,
                  }}
                  onClick={() => props.canGoBack && props.backTree()}
                  className={classes.refresh}
                >
                  <ArrowBackIcon
                    style={{
                      color: props.canGoBack ? colors.blue : "#999",
                      margin: "-3px 0px 0px -2px",
                    }}
                  />
                </WrapperIcon>
              </span>
            </Tooltip>

            <Tooltip title="Forward" arrow>
              <span>
                <WrapperIcon
                  aria-label="Forward"
                  style={{
                    backgroundColor: props.canGoForward ? "#fff" : "#e0e0e0",
                    cursor: props.canGoForward ? "pointer" : "not-allowed",
                    opacity: props.canGoForward ? 1 : 0.5,
                  }}
                  onClick={() => props.canGoForward && props.forwardTree()}
                  className={classes.refresh}
                >
                  <ArrowForwardIcon
                    style={{
                      color: props.canGoForward ? colors.blue : "#999",
                      margin: "-3px 0px 0px -2px",
                    }}
                  />
                </WrapperIcon>
              </span>
            </Tooltip>

            <Tooltip title="Home" arrow>
              <WrapperIcon
                aria-label="Home"
                style={{ backgroundColor: "#fff" }}
                onClick={() => props.clickHomeMap()}
                className={classes.refresh}
              >
                <HomeIcon
                  style={{ color: colors.blue, margin: "-3px 0px 0px -2px" }}
                />
              </WrapperIcon>
            </Tooltip>

            <Tooltip title="Refresh" arrow>
              <WrapperIcon
                aria-label="Refresh"
                onClick={refresh}
                className={classes.refresh}
              >
                <RefreshIcon
                  style={{ color: "#fff", margin: "-3px 0px 0px -2px" }}
                />
              </WrapperIcon>
            </Tooltip>
          </Box>

          <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

          {props?.mapPath?.length > 0 && (
            <>
              <Tooltip
                title={
                  loadingFolderDownload
                    ? "Preparing download..."
                    : "Download Folder as Zip"
                }
                arrow
              >
                <WrapperIcon
                  aria-label="Download Folder as Zip"
                  onClick={loadingFolderDownload ? undefined : downloadFolder}
                  className={classes.downloadZip}
                  style={{
                    opacity: loadingFolderDownload ? 0.7 : 1,
                    pointerEvents: loadingFolderDownload ? "none" : "auto",
                    position: "relative",
                  }}
                >
                  {loadingFolderDownload ? (
                    <CircularProgress
                      size={22}
                      sx={{ color: "#4caf50" }}
                      style={{ margin: "-3px 0px 0px -2px" }}
                    />
                  ) : (
                    <SystemUpdateAltIcon
                      style={{ color: "#4caf50", margin: "-3px 0px 0px -2px" }}
                    />
                  )}
                </WrapperIcon>
              </Tooltip>
              <Tooltip
                title="Download as Zip (large folders) — opens progress dialog"
                arrow
              >
                <WrapperIcon
                  onClick={downloadFolderV2}
                  className={classes.downloadZip}
                  style={{
                    position: "relative",
                    marginRight: 4,
                    border: `1px solid ${colors.blue}`,
                  }}
                >
                  <SystemUpdateAltIcon
                    style={{
                      color: colors.blue,
                      margin: "-3px 0px 0px -2px",
                      fontSize: 22,
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 2,
                      fontSize: 9,
                      fontWeight: 600,
                      color: colors.blue,
                    }}
                  >
                    v2
                  </span>
                </WrapperIcon>
              </Tooltip>
            </>
          )}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Grid View" arrow>
            <WrapperIconNoMargin
              aria-label="Grid View"
              onClick={props.toggleGridView}
              className={classes.refresh}
              style={{
                backgroundColor: props.viewMode === "grid" ? "#0076FF" : "#fff",
              }}
            >
              <GridViewIcon
                style={{
                  color: props.viewMode === "grid" ? "#fff" : "#0076FF",
                  margin: "-3px 0px 0px -2px",
                }}
              />
            </WrapperIconNoMargin>
          </Tooltip>
          <Tooltip title="List View" arrow>
            <WrapperIcon
              aria-label="List View"
              onClick={props.toggleListView}
              className={classes.refresh}
              style={{
                backgroundColor: props.viewMode === "list" ? "#0076FF" : "#fff",
              }}
            >
              <ListIcon
                style={{
                  color: props.viewMode === "list" ? "#fff" : "#0076FF",
                  margin: "-3px 0px 0px -2px",
                }}
              />
            </WrapperIcon>
          </Tooltip>
          <Tooltip title="Toggle recent files" arrow>
            <WrapperIcon
              aria-label="Toggle recent files"
              onClick={props.toggleRecent}
              className={
                props.showRecent
                  ? classes.recentFilesActive
                  : classes.recentFilesInActive
              }
            >
              <RecentIcon
                style={{
                  color: props.showRecent ? "#fff" : "#0076FF",
                  margin: "-3px 0px 0px -2px",
                }}
              />
            </WrapperIcon>
          </Tooltip>
          </Box>
          {/*<WrapperPathMapUl style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
                {props.mapPath.map((map, idx) => (
                  <WrapperPathMapLi
                    key={idx}
                    onClick={() => clickMap(map.id)}
                    className={idx <= props.mapPath.length ? "IK" : classes.PathActive}
                  >
                    {idx === 0 ? null : <WrapperPathMapSpan>/</WrapperPathMapSpan>}
                    {map.name}
                  </WrapperPathMapLi>
                ))}
              </WrapperPathMapUl>*/}
          {props.mapPath.length > 0 &&
            props.mapPath[props.mapPath.length - 1].name === "Trash" && (
              <Button
                onClick={clearTrashBin}
                sx={{
                  backgroundColor: "orange",
                  color: "white",
                  marginLeft: "8px",
                  "&:hover": {
                    background: "#ffaf7a",
                  },
                }}
              >
                Empty
              </Button>
            )}
          {props.selectedFiles.length > 10000 && (
            <WrapperIcon onClick={openMenuItems} className={classes.optionMenu}>
              <MoreHorizIcon
                style={{ color: "#0076FF", margin: "-3.5px 0px 0px -2px" }}
              />
            </WrapperIcon>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "10px",
            flex: 1,
            minWidth: 0,
          }}
        >
          <div
            style={{
              height: "36px",
              display: "flex",
              marginTop: "-16px",
              flex: 1,
              minWidth: 180,
            }}
          >
            <TextField
              inputRef={inputRef}
              variant="outlined"
              size="small"
              placeholder="Search..."
              autoComplete="off"
              value={props.searchQuery}
              onChange={handleSearchChange}
              onFocus={handleSearchFocus}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "4px",
                height: "36px",
                // Wider (responsive) so filenames are more readable
                width: "100%",
                maxWidth: 640,
                minWidth: 180,
                "& .MuiOutlinedInput-root": {
                  margin: "0",
                  height: "36px",
                  fontSize: "14px",
                },
                "& input": { padding: "2px 1px" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={iconSearch}
                      alt="Search"
                      style={{ width: 18, height: 18 }}
                    />
                  </InputAdornment>
                ),
                endAdornment: (
                  <>
                    {props.autoCompleteLoading && props.searchQuery && props.searchQuery.trim() !== "" ? (
                      <InputAdornment position="end">
                        <CircularProgress size={18} />
                      </InputAdornment>
                    ) : null}
                    {props.searchQuery && props.searchQuery.length > 0 ? (
                      <Backspace
                        style={{
                          color: "rgb(251, 167, 48)",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                        onClick={props.resetSearch}
                        className={classes.buttonSearch}
                        alt="Delete"
                      />
                    ) : null}
                  </>
                ),
              }}
              inputProps={{ autoComplete: "off" }}
              style={{ height: "36px" }}
            />
          </div>

          {props.searchActive ? (
            <Button
              onClick={props.resetSearch}
              variant="contained"
              sx={{
                backgroundColor: "#0076FF",
                color: "#fff",
                height: "36px",
                minWidth: "40px",
                borderRadius: "4px",
                padding: "0",
                "&:hover": {
                  backgroundColor: "#005bb5",
                },
              }}
            >
              <CloseIcon />
            </Button>
          ) : (
            <Button
              onClick={handleSearchClick}
              variant="contained"
              sx={{
                backgroundColor: "#0076FF",
                color: "#fff",
                height: "36px",
                fontWeight: "bold",
                fontSize: "14px",
                textTransform: "none",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#005bb5",
                },
              }}
            >
              Search
            </Button>
          )}

          <Tooltip title="Filter" arrow>
            <WrapperIcon
              onClick={props.handleFilterClick}
              className={classes.refresh}
              style={{ backgroundColor: "#fff" }}
            >
              <FilterAltIcon
                style={{ color: "#0076FF", margin: "-3px 0px 0px -2px" }}
              />
            </WrapperIcon>
          </Tooltip>
          <div style={{ position: "relative" }}>
            <SearchAutocomplete
              ref={paperRef}
              anchorEl={searchAnchorEl}
              results={props.autoCompleteResults}
              loading={props.autoCompleteLoading}
              query={props.searchQuery}
              onSelect={handleSelectResult}
              onViewAll={() => {
                props.handleSearchClick(props.searchQuery);
                setSearchAnchorEl(null);
              }}
              onClose={() => setSearchAnchorEl(null)}
              currentPath={currentPath}
            />
          </div>
        </div>
      </div>
      {/* </Grid>
      </Grid> */}
      <NewFolderDocPlace
        show={showRootFolderModal}
        close={() => setShowRootFolderModal(false)}
        newFolder={(folderData) => {
          props.newFolder(folderData);
          setShowRootFolderModal(false);
        }}
        treePrevius={props.mapPath}
      />
    </Wrapper>
  );
}

export default NavDocPlace;
